// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {395: "4c1c7414dba26db7",430: "2233154c88d2986c",766: "58886605ea804afc",835: "85802a4071f1d926",}[chunkId] + ".css"
}